import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { BridgeService } from "@vega/bridge";
import { TranslatePipe } from "@vega/localization";
import { IconComponent } from "@vega/ui-visualization/icon";

@Component({
    selector: "vega-page-not-found",
    templateUrl: "./page-not-found.component.html",
    styleUrls: ["./page-not-found.component.less"],
    imports: [TranslatePipe, IconComponent]
})
export class PageNotFoundComponent {
    private cefBridgeService = inject(BridgeService);
    private _router = inject(Router);
    public isTopVisEmbedded: boolean;

    constructor(
    ) {
        this.isTopVisEmbedded = this.cefBridgeService.isBridgeActive;
    }

    public navigateToUseCaseSelector(): void {
        this._router.navigate(["main-navigation"]);
    }
}
